import { AdditionalMessageUI } from "./AdditionalMessageUI";
import { StandardProps } from "../componentMap";
import { useVariant } from "../../hooks/useVariant/useVariant";
import { removeIFCMessages } from "../../utils/product/interestFreeCredit/removeIFCMessages";

export function AdditionalMessage({ product }: Pick<StandardProps, "product">) {
  const { variant } = useVariant(product);

  const { messaging = [] } = variant;

  const additionalMessages = removeIFCMessages(
    messaging.filter((message) => message.type === "additional"),
  ).map(({ title }) => title);

  return <AdditionalMessageUI messages={additionalMessages} />;
}
